export const ORGANIZATIONS_ENDPOINTS = {
  ORGANIZATION_TRAINERS: (organizationId: string) => `organizations/${organizationId}/trainers`,
  ORGANIZATION_TRAINERS_BY_DADESKTOP_ID: (daDesktopId: number) =>
    `organizations/by-dadesktop-id/${daDesktopId}/trainers`,
  ORGANIZATION_INVITATIONS: (organizationId: string) =>
    `organizations/${organizationId}/invitations`,
  ORGANIZATION_INVITATION_CANCEL: (organizationId: string, invitationId: string) =>
    `organizations/${organizationId}/invitations/${invitationId}`,
  ORGANIZATION_USERS: (organizationId: string) => `organizations/${organizationId}/users`,
  REVOKE_TRAINER_ROLE: (organizationId: string, userId: string) =>
    `organizations/${organizationId}/users/${userId}/revoke-trainer`,
  ORGANIZATION_USERS_HISTORY: (organizationId: string) =>
    `organizations/${organizationId}/users/history`,
  MY_MANAGED_ORGANIZATIONS: 'organizations/my-managed',
  MANAGED_ORGANIZATION_USERS: 'organizations/managed-users',
  INVITE_TRAINER: (organizationId: string) => `organizations/${organizationId}/trainers/invite`,
  TRAINER_INVITATION_ACCEPT: (organizationId: string) =>
    `organizations/${organizationId}/accept-invitation`,
  TRAINER_INVITATION_REJECT: (organizationId: string) =>
    `organizations/${organizationId}/reject-invitation`,
  MY_PENDING_TRAINER_INVITATIONS: 'organizations/trainer-invitations/pending',
  SYSTEM_INVITATIONS: 'organizations/invitations/system',
  INVITATION_BY_TOKEN: (token: string) => `invitations/by-token/${encodeURIComponent(token)}`,
  INVITATION_ACCEPT_PUBLIC: 'invitations/accept-public',
  INVITATION_REJECT: 'invitations/reject'
} as const;
